"use client";
import { jsx } from 'react/jsx-runtime';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { initQueryClient } from './create-hooks.esm.mjs';
import { TsrQueryClientContext } from './use-tsr-query-client.esm.mjs';

function TsRestInnerProvider({ children, contract, clientOptions, }) {
    const queryClient = useQueryClient();
    const tsrQueryClient = useMemo(() => {
        return initQueryClient(contract, clientOptions, queryClient);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryClient]);
    return (jsx(TsrQueryClientContext.Provider, { value: tsrQueryClient, children: children }));
}

export { TsRestInnerProvider };
